module.exports = __webpack_public_path__ + "img/Truppführer.559e635e.svg";